import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { useDialog } from '@shared-ui/dialog-context';
import { useLocalization } from '@shared-ui/localization-context';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

const LinkTracked = ClickTracker(Link);

export const BreakfastAndWifiDisclaimer: React.FC = () => {
  const { id, legalDisclaimer } = usePropertyListing();
  const dialogId = `BreakfastAndWifiDisclaimerDialog-${id}`;
  const [, dialogActions, DialogComponent] = useDialog(dialogId, 'pwaDialog');
  const l10n = useLocalization();

  const openDialog = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dialogActions.openDialog();
  };

  const onDismiss = (): void => {
    dialogActions.closeDialog();
  };

  if (!legalDisclaimer) {
    return null;
  }

  return (
    <UitkLayoutGrid>
      {legalDisclaimer.title && (
        <UitkMoreInfoTrigger>
          <LinkTracked linkName="Breakfast and Wifi Disclaimer Dialog" rfrr=".BreakfastAndWifi.DisclaimerDialog" onClick={openDialog}>
            <UitkLayoutGridItem>
              <span className="breakfast-and-wifi-disclaimer-link-text">{legalDisclaimer.title}</span>
            </UitkLayoutGridItem>
            <UitkIcon name="info_outline" className="pwa-theme--grey-700 all-r-padding-half" />
          </LinkTracked>
        </UitkMoreInfoTrigger>
      )}

      {legalDisclaimer.disclaimerContents && (
        <DialogComponent>
          <UitkDialog returnFocusOnClose>
            <UitkDialogContent>
              <ul className="uitk-type-list-300">
                {legalDisclaimer.disclaimerContents.map((listItem, index) => (
                  <li key={index}>{listItem}</li>
                ))}
              </ul>
            </UitkDialogContent>
            <UitkDialogFooter
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('close'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </DialogComponent>
      )}
    </UitkLayoutGrid>
  );
};
BreakfastAndWifiDisclaimer.displayName = 'BreakfastAndWifiDisclaimer';
